module.exports = __webpack_public_path__ + "img/product10.baee7bfc.jpg";